<template xmlns="http://www.w3.org/1999/html">
    <b-modal v-model="visible" size="lg">
        <template v-slot:modal-header="{ close }">
            <div class="row" style="width: 100%">
                <div class="col-md-10 offset-md-1 text-center d-flex justify-content-center">
                    <h3> {{ __('contractor_group_edit') }}
                        <button-open-help-modal :color="'dark'" :in-extra-div="false"
                                                :helpName="analyzeType == 'sell'? 'ASA-004' : 'ASB-004'"/>
                    </h3>
                </div>
                <div class="col-md-1">
                    <button type="button" class="close" v-on:click="visible = false">
                        <span aria-hidden="true">&times;</span>
                        <span class="sr-only">{{ __('close') }}</span>
                    </button>
                </div>
            </div>
        </template>

        <template v-slot:default="{}">
            <div v-for="(group, index) in contractorGroups" :key="index" class="mt-3">
                <div class="ibox-title" style="height: 30px !important;padding: 5px 5px 3px 15px">
                    <p class="group-container text-bold">
                        {{ group.name == 'unallocated' ? __('unallocated_group') : group.name }} <span
                        class="text-right">

                        <span class="tooltip-more icon-danger"
                              v-if="group.name != 'unallocated' && group.name.length > 32"
                              :data-original-title=" __('too_long_group_name') "
                              :data-toggle="'tooltip'"
                              :data-placement="'top'">
                                <i class="fas fa-exclamation-triangle" style="color:red !important;"></i>
                            </span>
                         <a  v-if="group.name != 'unallocated'"
                             class=""
                             :data-toggle="'tooltip'"
                             :data-placement="'top'"
                             :data-original-title="__('edit_name')"
                             @click="editGroupName(group.name)"
                         >
                            <i class="fa fa-pen text-white"></i>
                        </a>
                        <a v-if="canMoveDown(index,group)"
                           class="reorder arrow-down "
                           :data-toggle="'tooltip'"
                           :data-placement="'top'"
                           :data-original-title="__('move_down')"
                           @click="moveGroupDown(index)"
                        >
                            <i class="fas fa-arrow-down text-white"></i>
                        </a>
                         <a
                             v-if="canMoveUp(index,group)"
                             class="reorder arrow-up"
                             :data-toggle="'tooltip'"
                             :data-placement="'top'"
                             :data-original-title="__('move_up')"
                             @click="moveGroupUp(index)"
                         >
                            <i class="fas fa-arrow-up text-white"></i>
                        </a>
                         <a v-if="group.name != 'unallocated'"
                            class="icon-delete-embedded"
                            data-toggle="tooltip"
                            data-placement="top"
                            :data-original-title="__('delete')"
                            @click="showSwalDelete(group, index)"
                         >
                             <i class="fa fa-trash text-white"></i>
                        </a>
                    </span></p>

                </div>
                <div v-for="contractor in group.contractors"
                     v-if="group.contractors.length > 0 && contractor.id != undefined" :key="contractor.id"
                     class="row mt-1">
                    <div class="col max-w-40">
                        <input type="checkbox" v-model="contractor.checked">
                    </div>
                    <div class="col" v-html="getContractorDescription(contractor)">
                    </div>
                </div>
            </div>


        </template>
        <template v-slot:modal-footer="{}">
            <div class="d-flex w-100">
                <!-- Przyciski po lewej -->
                <div class="d-flex gap-3 flex-grow-1">
                    <div class="white-space-no-wrap" v-if="checkedContractors > 0">
                        <button type="button" class="btn btn-primary" @click="assignContractorsToGroup()">
                            {{ __('assign_to_group') }}
                        </button>
                    </div>
                    <div class="white-space-no-wrap ml-2">
                        <button type="button" class="btn btn-primary" @click="createGroup()">
                            {{ __('create_group') }}
                        </button>
                    </div>
                    <div class="white-space-no-wrap ml-2" v-if="patternId == null">
                        <button type="button" class="btn btn-primary" @click="importContractorGroups()">
                            {{ __('import_groups') }}
                        </button>
                    </div>
                </div>

                <!-- Przyciski po prawej -->
                <div class="d-flex gap-3">
                    <div class="white-space-no-wrap">
                        <button type="button" class="btn btn-white" v-on:click="visible = false">{{ __('cancel') }}</button>
                    </div>
                    <div class="white-space-no-wrap ml-2" v-if="!checkNamesLength">
                        <button type="button" class="btn btn-primary" @click="saveContractorGroups()">
                            {{ __('save') }}
                        </button>
                    </div>

                </div>
            </div>
        </template>


    </b-modal>
</template>
<style>
.group-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
</style>
<script>
import actions from "../../vuex/action_types";
import Numeric from "vuelidate/lib/validators/numeric";

export default {
    name: "ModalEditContractorGroup",
    data: function () {
        return {
            visible: false,
            contractorGroups: [],
        }
    },
    props: {
        groups: {
            type: Array
        },
        analyzeType: {
            type: String
        },
        patternId:{
            type:Numeric,
            default: null,
        }
    },
    methods: {
        getContractorDescription(contractor) {
            const descriptionArray = [];

            if (contractor.reference_number) {
                descriptionArray.push(contractor.reference_number);
            }
            if (contractor.name) {
                descriptionArray.push('<b>' + contractor.name + '</b>');
            }
            if (contractor.address) {
                descriptionArray.push(contractor.address);
            }
            if (contractor.address_2) {
                descriptionArray.push(contractor.address_2);
            }
            if (contractor.zip) {
                descriptionArray.push(contractor.zip);
            }
            if (contractor.city) {
                descriptionArray.push(contractor.city);
            }
            if (contractor.country_id) {
                descriptionArray.push(contractor.country?.iso_code);
            }
            if (contractor.department_country_id && contractor.department_country) {
                descriptionArray.push(contractor.department_country.iso_code);
            }
            descriptionArray.push('<b>' + this.__(contractor.id_number?.pattern_name) + '</b>' + (contractor.id_number?.pattern_name != 'none' ? (': '+contractor.identification_number) : ''));
            descriptionArray.push('<b>' + this.__(contractor.secondary_id_number_relation?.pattern_name) + '</b> ' + (contractor.secondary_id_number_relation?.pattern_name != 'none' ? (': '+contractor.secondary_id_number) : ''));

            // Połącz elementy tablicy w jeden string, oddzielając je przecinkiem
            return descriptionArray.join(', ');
        },
        canMoveDown(index, group) {
            if (group.name == 'unallocated') {
                return false;
            }
            const unallocatedIndex = this.contractorGroups.findIndex(group => group.name === 'unallocated');
            if (index == unallocatedIndex - 1) {
                return false;
            }
            if (index == this.contractorGroups.length - 1) {
                return false;
            }
            return true;
        },
        canMoveUp(index, group) {
            if (group.name == 'unallocated') {
                return false;
            }
            const unallocatedIndex = this.contractorGroups.findIndex(group => group.name === 'unallocated');
            if (index == 0) {
                return false;
            }
            return true;
        },
        moveGroupDown(index) {
            if (index < this.contractorGroups.length - 1) {
                const temp = _.cloneDeep(this.contractorGroups);
                const groupToMove = temp[index];
                temp[index] = temp[index + 1];
                temp[index + 1] = groupToMove;
                this.contractorGroups = temp;
            }
        },
        moveGroupUp(index) {
            if (index <= this.contractorGroups.length - 1) {
                const temp = _.cloneDeep(this.contractorGroups);
                const groupToMove = temp[index];
                temp[index] = temp[index - 1];
                temp[index - 1] = groupToMove;
                this.contractorGroups = temp;
            }
        },
        showSwalDelete(group, index) {
            let self = this;
            this.$swal({
                title: '',
                text: self.__("delete_allocation_group"),
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: self.__("delete"),
                cancelButtonText: self.__("cancel"),
                closeOnConfirm: true,
                reverseButtons: true
            }).then(result => {
                if (result.value === true) {
                    self.handleDeleteGroup(group, index);
                }
            });
        },
        handleDeleteGroup(group, index) {
            let unallocatedGroupIndex = this.contractorGroups.findIndex(group => group.name === 'unallocated');
            if (unallocatedGroupIndex == -1) {
                this.contractorGroups.push({name: 'unallocated', contractors: []})
                unallocatedGroupIndex = this.contractorGroups.findIndex(group => group.name === 'unallocated')
            }
            for (let i = 0; i < this.contractorGroups[index].contractors.length; i++) {
                const contractor = this.contractorGroups[index].contractors[i];
                this.contractorGroups[unallocatedGroupIndex].contractors.push(contractor);
            }
            this.contractorGroups.splice(index, 1);
        },
        editGroupName(name) {
            this.$emit('editContractorGroupName', name);
        },
        assignContractorsToGroup() {
            this.$emit('assignContractorsToGroup', this.contractorGroups);
        },
        createGroup() {
            this.$emit('createGroup', this.contractorGroups);
        },
        importContractorGroups() {
            toggleLoader()
            this.$emit('importContractorGroups', this.contractorGroups);
        },
        saveContractorGroups() {
            toggleLoader()
            this.$emit('saveContractorGroups', this.contractorGroups);
        }
    },
    computed: {
        checkNamesLength() {
            const hasInvalidLength = this.groups.some(group => group.name !== 'unallocated' && group.name.length > 32);

            if (hasInvalidLength) {
                return true;
            } else {
                return false;
            }
        },
        checkedContractors() {
            let sumCheckedContractors = 0;

            this.contractorGroups.forEach(group => {
                if (group.contractors.length > 0) {
                    group.contractors.forEach(contractor => {
                        if (contractor.checked) {
                            sumCheckedContractors++;
                        }
                    });
                }
            });
            return sumCheckedContractors
        }
    }
}
</script>

<style scoped>

</style>
